import { render, staticRenderFns } from "./emergencyBase.vue?vue&type=template&id=0353d3e2&scoped=true&"
import script from "./emergencyBase.vue?vue&type=script&lang=js&"
export * from "./emergencyBase.vue?vue&type=script&lang=js&"
import style0 from "./emergencyBase.vue?vue&type=style&index=0&id=0353d3e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353d3e2",
  null
  
)

export default component.exports